import React, { useEffect, useState } from 'react';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from './../firebase-config';
import Spinner from '../components/Spinner';

export default function Publications() {
  // useScript('assets/js/publication-table.js');
  const [publicationsData, setPublicationsData] = useState([]);
  const publicationsDocRef = collection(db, 'publications-data');
  const publicationQuery = query(publicationsDocRef, orderBy("sNo"))

  const [achievementsData, setAchievementsData] = useState([]);
  const achievementsDocRef = collection(db, 'achievements-data');

  const getPublicationsData = async () => {
    const querySnapshot = await getDocs(publicationQuery);
    let d = [];
    querySnapshot.forEach((doc) => {
      return d.push({
        id: doc.id,
        data: doc.data(),
      });
    });
    setPublicationsData(d);
  };

  const getAchievementsData = async () => {
    const querySnapshot = await getDocs(achievementsDocRef);
    let d = [];
    querySnapshot.forEach((doc) => {
      return d.push({
        id: doc.id,
        data: doc.data(),
      });
    });
    setAchievementsData(d);
  };

  useEffect(() => {
    document.title = 'Dr. Nithin M | Publications';
    getPublicationsData();
    getAchievementsData();
  }, []);
  return (
    <section class='blog-section'>
      <div>
        <h2 class='section-title'>Publications</h2>
      </div>
      {publicationsData.length > 0 ? (
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <table
                class='table table-striped table-responsive'
                id='publication-table'
              >
                {/* <thead>
                  <tr>
                    <th scope='col'>#</th>
                    <th scope='col'>Title</th>
                  </tr>
                </thead> */}
                <tbody>
                  {publicationsData.map((publication, i) => {
                    return (
                      <tr>
                        <th scope='row'>{i + 1}</th>
                        <td>{publication['data']['title']}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
      <hr style={{ 'border-width': '3px' }} />
      <div>
        <h2 class='section-title'>Achievements & Awards</h2>
      </div>
      {achievementsData.length > 0 ? (
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <table
                class='table table-striped table-responsive'
                id='achievement-table'
              >
                {/* <thead>
                  <tr>
                    <th scope='col'>#</th>
                    <th scope='col'>Title</th>
                  </tr>
                </thead> */}
                <tbody>
                  {achievementsData.map((achievement, i) => {
                    return (
                      <tr>
                        <th scope='row'>{i + 1}</th>
                        <td>{achievement['data']['title']}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <Spinner />
      )}
    </section>
  );
}
